import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Dropdown from './_dropdown.js'
import RangeFilter from './_range-filter.js'

export default {
  name: 'Filters',
  values: {
    filterContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    filterRangeRowContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    filterRangeTitleContainer: {
      configSet: Text,
      configValues: {},
    },
    filterStatusRowContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    filterStatusTitleContainer: {
      configSet: Text,
      configValues: {},
    },
    dropdown: {
      configSet: Dropdown,
      configValues: {},
    },
    excludedStatusTypes: [
    ],
    defaultStatusFilter: undefined,
    rangeFilterOptions: [
    ],
    defaultRangeFilter: {
      configSet: RangeFilter,
      configValues: {},
    },
    itemsPerPage: 20,
  },
  meta: {
    extendable: false,
  },
}
